import {FormattedMessage} from 'react-intl';
import {Age} from '.cache/__types__';

export const translations = {
    [Age.Undefined]: <FormattedMessage defaultMessage="Nespecifikováno" />,
    [Age.Between_1_10]: <FormattedMessage defaultMessage="Do 10 let" />,
    [Age.Between_10_30]: <FormattedMessage defaultMessage="10 - 30 let" />,
    [Age.Between_30_50]: <FormattedMessage defaultMessage="30 - 50 let" />,
    [Age.Over_50]: <FormattedMessage defaultMessage="Nad 50\u00a0let" />,
};
